module.exports = __webpack_public_path__ + "img/apartment-architectural-design-architecture-building.85e14258.jpg";